module.exports = __webpack_public_path__ + "images/ZALogo.e4e30d00.png";